import {
    h, ComponentChildren, JSX, Ref
} from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./PillButton.module.css";

type NativeButtonProps = JSX.HTMLAttributes<HTMLButtonElement>;

interface Props extends NativeButtonProps {
    buttonRef?: Ref<HTMLButtonElement>;
    children?: ComponentChildren;
    active?: boolean;
    onClick?: (event: MouseEvent) => void;
}

function Button({
    class: cssClass,
    buttonRef,
    children,
    active,
    ...nativeButtonProps
}: Props) {
    return (
        <button
            {...nativeButtonProps}
            class={classname(styles.pillButton, "caption-1 medium", cssClass, {
                [styles.active]: active
            })}
            ref={buttonRef}>
            {children}
        </button>
    );
}

export default Button;
